// Live Blackpurl contact lookup. Booking submissions remain a local design preview.
window.IgnitionLookupConfig = Object.freeze({
  mode: 'live',
  endpoint: 'https://ignition-service-lookup.ignition-motorsports.workers.dev'
});

window.IgnitionBookingConfig=Object.freeze({
  mode:'live',
  endpoint:'https://ignition-service-lookup.ignition-motorsports.workers.dev'
});

(() => {
  'use strict';
  const root=document.getElementById('ims-service-app');
  if(!root)return;
  const byId=id=>root.querySelector('#'+id);
  const config = window.IgnitionLookupConfig || {mode:'demo'};
  const demo = config.mode !== 'live';
  const sample = Object.freeze({firstName:'Alex',lastName:'Rider',phone:'+12505550100'});
  const examples = Object.freeze([
    {year:'2024',make:'CFMOTO',model:'800MT Touring',type:'Motorcycle / dirt bike'},
    {year:'2023',make:'CFMOTO',model:'CFORCE 600 Touring',type:'ATV'}
  ]);
  const phone = value => {
    if(!/^[+\d().\s-]+$/.test(value))return '';
    let digits=value.replace(/\D/g,'');if(digits.length===11&&digits.startsWith('1'))digits=digits.slice(1);
    return /^[2-9]\d{2}[2-9]\d{6}$/.test(digits)?'+1'+digits:'';
  };
  const surname = value => value.normalize('NFKC').replace(/[\u2018\u2019]/g,"'").replace(/[\u2010\u2011]/g,'-').trim().replace(/\s+/g,' ').toLocaleLowerCase('en-CA');
  const label = vehicle => [vehicle.year,vehicle.make,vehicle.model,vehicle.sub_model].filter(Boolean).join(' ');
  let searchResult=null,selection=null,requestVersion=0,controller=null;
  function notifyChange(){root.dispatchEvent(new CustomEvent('vehicle-lookup-change'));}
  function error(message){byId('lookup-error').textContent=message;byId('lookup-error').hidden=!message;}
  function clearAutoVehicle(){
    ['year','make','model','usage','vin'].forEach(id=>byId(id).value='');
    root.querySelectorAll('input[name="vehicle_type"]').forEach(input=>input.checked=false);
  }
  function clearSelection(){
    if(selection)clearAutoVehicle();selection=null;
    byId('lookup-panel').hidden=false;byId('saved-vehicle-selection').hidden=true;byId('manual-vehicle-fields').hidden=false;byId('vehicle-type-fields').disabled=false;
    byId('saved-vehicle-label').textContent='';byId('saved-vehicle-contact').textContent='';notifyChange();
  }
  function resetSearch(){
    requestVersion++;controller?.abort();controller=null;searchResult=null;
    byId('lookup-vehicles').hidden=true;byId('saved-vehicle-list').replaceChildren();
    byId('lookup-open').disabled=false;byId('lookup-open').textContent='Search my ride';
    byId('lookup-panel')?.removeAttribute('aria-busy');error('');
  }
  function updateContactSummary(){
    byId('lookup-contact-name').textContent=[byId('first-name').value.trim(),byId('last-name').value.trim()].filter(Boolean).join(' ');
    byId('lookup-contact-phone').textContent=byId('phone').value.trim();
    if(selection)byId('saved-vehicle-contact').textContent='Matched using your last name and phone number.';
  }
  function syncContact(){
    const identity=selection||searchResult;
    if(identity&&(phone(byId('phone').value)!==identity.phone||surname(byId('last-name').value)!==identity.surname)){
      clearSelection();resetSearch();byId('lookup-content').hidden=true;byId('lookup-open').hidden=false;
      byId('contact-match-note').textContent='Your contact details changed. Search again to choose a matching ride, or enter it manually.';
      byId('contact-match-note').hidden=false;
    }
    updateContactSummary();
  }
  function manual(){
    resetSearch();clearSelection();byId('lookup-content').hidden=true;byId('lookup-open').hidden=false;
    root.querySelector('input[name="vehicle_type"]').focus();
  }
  function showVehicles(){
    const list=byId('saved-vehicle-list');list.replaceChildren();
    for(const vehicle of searchResult.vehicles){
      const button=document.createElement('button');button.type='button';button.className='saved-vehicle-card';
      const description=document.createElement('span');
      if(demo){const tag=document.createElement('small');tag.textContent='Example ride';description.append(tag);}
      const title=document.createElement('strong');title.textContent=label(vehicle);description.append(title);
      const action=document.createElement('span');action.className='saved-card-action';action.textContent='Choose this ride';
      button.append(description,action);button.addEventListener('click',()=>select(vehicle));list.append(button);
    }
    byId('lookup-vehicles').hidden=false;byId('lookup-open').hidden=true;
    list.querySelector('button')?.focus({preventScroll:true});
  }
  async function search(){
    syncContact();resetSearch();clearSelection();
    byId('lookup-content').hidden=false;
    const last=surname(byId('last-name').value),number=phone(byId('phone').value);
    if(!last||!number){error('Add your last name and a valid phone number in contact details to search for your ride.');return;}
    const version=requestVersion;
    searchResult={surname:last,phone:number,vehicles:[],expires:0};
    byId('lookup-open').disabled=true;byId('lookup-open').textContent='Searching…';
    byId('lookup-panel').setAttribute('aria-busy','true');
    try{
      let result;
      if(demo){
        result={vehicles:last===surname(sample.lastName)&&number===sample.phone?examples:[],expires_in_seconds:900};
      }else{
        const endpoint=new URL(config.endpoint);
        if(endpoint.protocol!=='https:'||endpoint.username||endpoint.password||endpoint.search||endpoint.hash)throw new Error('configuration');
        controller=new AbortController();const timer=setTimeout(()=>controller.abort(),10000);
        try{
          const response=await fetch(new URL('/v1/search',endpoint),{method:'POST',headers:{'Content-Type':'application/json'},
            body:JSON.stringify({lastName:last,mobile:number}),credentials:'omit',cache:'no-store',redirect:'error',signal:controller.signal});
          if(!response.ok)throw new Error(response.status===429?'rate':'unavailable');
          result=await response.json();
        }finally{clearTimeout(timer);}
        if(!result||!Array.isArray(result.vehicles)||result.vehicles.some(v=>!v||typeof v.make!=='string'||typeof v.model!=='string'||!/^[a-f0-9]{64}$/.test(v.vehicle_token||'')))throw new Error('unavailable');
        if(result.vehicles.length&&(!/^[A-Za-z0-9_-]{43}$/.test(result.session_token||'')||!Number.isFinite(result.expires_in_seconds)||result.expires_in_seconds<=0))throw new Error('unavailable');
      }
      if(version!==requestVersion)return;
      if(!result.vehicles.length){
        searchResult=null;
        error(demo?'No example ride matches these details. You can enter your ride manually, or use the example details in step 2.':'We couldn’t find a matching ride. Check your last name and phone number, or enter your ride manually.');return;
      }
      searchResult={surname:last,phone:number,vehicles:result.vehicles,sessionToken:result.session_token,
        expires:Date.now()+Math.min(result.expires_in_seconds,900)*1000};showVehicles();
    }catch(e){
      if(version!==requestVersion)return;
      searchResult=null;
      error(e.message==='rate'?'Please try searching again later, or enter your ride manually.':'Ride search is temporarily unavailable. You can still enter your ride manually.');
    }finally{
      if(version===requestVersion){controller=null;byId('lookup-open').disabled=false;byId('lookup-open').textContent='Search my ride';byId('lookup-panel').removeAttribute('aria-busy');}
    }
  }
  function select(vehicle){
    syncContact();
    if(!searchResult||searchResult.expires<=Date.now()){
      resetSearch();byId('lookup-open').hidden=false;error('Please search again to refresh your ride choices.');return;
    }
    clearAutoVehicle();selection={...vehicle,phone:searchResult.phone,surname:searchResult.surname,expires:searchResult.expires,sessionToken:searchResult.sessionToken};
    byId('year').value=vehicle.year||'';byId('make').value=vehicle.make;byId('model').value=[vehicle.model,vehicle.sub_model].filter(Boolean).join(' ');
    byId('manual-vehicle-fields').hidden=true;byId('vehicle-type-fields').disabled=true;byId('lookup-content').hidden=true;byId('lookup-open').hidden=true;
    byId('lookup-panel').hidden=true;byId('saved-vehicle-selection').hidden=false;byId('saved-vehicle-label').textContent=label(vehicle);updateContactSummary();
    byId('contact-match-note').textContent='These contact details were used to find your selected ride.';byId('contact-match-note').hidden=false;
    notifyChange();byId('saved-vehicle-selection').scrollIntoView({behavior:'smooth',block:'center'});
  }
  byId('lookup-open').addEventListener('click',search);
  byId('lookup-edit-contact').addEventListener('click',()=>root.dispatchEvent(new CustomEvent('edit-booking-contact')));
  byId('lookup-manual').addEventListener('click',manual);
  byId('lookup-example').addEventListener('click',()=>{
    if(!demo)return;
    resetSearch();clearSelection();byId('lookup-content').hidden=true;byId('lookup-open').hidden=false;
    byId('first-name').value=sample.firstName;byId('last-name').value=sample.lastName;byId('phone').value='250-555-0100';
    byId('contact-match-note').textContent='Example details ready. Choose “Search my ride” in the next step to see matching rides.';
    byId('contact-match-note').hidden=false;updateContactSummary();byId('phone').focus({preventScroll:true});
  });
  byId('saved-vehicle-change').addEventListener('click',()=>{
    clearSelection();byId('lookup-content').hidden=false;
    if(!searchResult||searchResult.expires<=Date.now()){resetSearch();byId('lookup-open').hidden=false;byId('lookup-open').focus();}
    else showVehicles();
  });
  ['phone','last-name','first-name'].forEach(id=>byId(id).addEventListener('input',syncContact));
  root.querySelectorAll('.lookup-preview-notice').forEach(el=>el.hidden=!demo);
  byId('saved-selection-heading').textContent=demo?'SELECTED RIDE · EXAMPLE':'SELECTED RIDE';
  window.IgnitionVehicleLookup={
    reset(){resetSearch();clearSelection();byId('lookup-content').hidden=true;byId('lookup-open').hidden=false;byId('contact-match-note').hidden=true;},
    prepare:syncContact,
    validate(){
      syncContact();
      if(selection&&selection.expires<=Date.now()){
        clearSelection();resetSearch();byId('lookup-open').hidden=false;
        return 'Your ride selection expired. Search again or enter your ride manually.';
      }return '';
    },
    summary(){return selection?(demo?'Example ride matched by last name and phone':'Ride matched by last name and phone; staff to confirm details'):'Vehicle entered manually';},
    selectionTokens(){return !demo&&selection?{sessionToken:selection.sessionToken,vehicleToken:selection.vehicle_token}:null;},
    get hasSelection(){return Boolean(selection);}
  };
  updateContactSummary();
})();
(()=>{const root=document.getElementById('ims-service-app');if(!root||root.dataset.initialized)return;root.dataset.initialized='true';
'use strict';
const services=[...root.querySelectorAll('[data-start-service]')].map(button=>[button.dataset.startService,button.lastElementChild.textContent]);
const $ = s => root.querySelector(s);
const $$ = s => [...root.querySelectorAll(s)];
let step = 0;
let requestPreview = null;
let requestReceipt = null;
let submitting = false;
let pendingBooking = null;
let lockedControls = null;
const bookingConfig=window.IgnitionBookingConfig||{mode:'preview'};
const liveBooking=bookingConfig.mode==='live';
const form = $('#booking-form');
$$('[data-start-service]').forEach(button=>button.addEventListener('click',()=>startWithService(button.dataset.startService)));
$$('input[name=services]').forEach(input=>input.addEventListener('change',updateSummary));
function selectedServices(){return $$('input[name="services"]:checked').map(input=>services.find(s=>s[0]===input.value)[1]);}
function updateSummary(){
  const selected=selectedServices();const target=$('#summary-services');target.replaceChildren();
  if(selected.length){const list=document.createElement('ul');list.className='summary-list';selected.forEach(value=>{const item=document.createElement('li');item.textContent=value;list.append(item)});target.append(list)}
  else{const p=document.createElement('p');p.className='summary-empty';p.textContent='Your selected services will appear here.';target.append(p)}
  $('.selection-count').textContent=selected.length?`${selected.length} service${selected.length===1?'':'s'} selected`:'Choose your services above';
  const ride=[$('#year').value,$('#make').value.trim(),$('#model').value.trim()].filter(Boolean).join(' ');
  $('#summary-vehicle').textContent=ride;$('#summary-vehicle').hidden=!ride;
  $('#summary-pickup').hidden=!$('#pickup').checked;
  if(selected.length)$('#form-error').hidden=true;
}
function startWithService(id){$(`#service-${id}`).checked=true;step=0;updateSummary();if(location.hash==='#book'){showStep(0);scrollTopPage()}else location.hash='book';}
$('#unsure-start').addEventListener('click',()=>startWithService('unsure'));
$('#pickup-start').addEventListener('click',()=>{$('#pickup').checked=true;step=0;updateSummary()});
$('#pickup').addEventListener('change',updateSummary);
function scrollTopPage(){window.scrollTo({top:0,behavior:'instant'})}
function route(){
  let view=location.hash==='#book'?'book':['#request-preview','#request-received'].includes(location.hash)&&requestPreview?'result':'service';
  root.dataset.view=view;
  $('#service-view').hidden=view!=='service';$('#book-view').hidden=view!=='book';$('#result-view').hidden=view!=='result';
  document.title=`${view==='book'?'Book a Service':view==='result'?(requestReceipt?'Request Received':'Your Request Preview'):'Service'} | Ignition Motorsports`;
  if(view==='book'){showStep(step,false);scrollTopPage();$('#book-view h1').focus({preventScroll:true})}
  else if(view==='result'){scrollTopPage();$('#result-view h1').focus({preventScroll:true})}
  else if(location.hash==='#services'){$('#services').scrollIntoView({behavior:'smooth'})}
  else{scrollTopPage();$('#service-view h1').focus({preventScroll:true})}
}
function showStep(next,focus=true){
  step=next;$('#form-error').hidden=true;
  if(step===2)window.IgnitionVehicleLookup.prepare();
  $$('.form-step').forEach((element,index)=>element.hidden=index!==step);
  $$('.progress li').forEach((element,index)=>{element.classList.toggle('current',index===step);element.classList.toggle('complete',index<step);if(index===step)element.setAttribute('aria-current','step');else element.removeAttribute('aria-current')});
  updateSummary();
  if(focus){$('.progress').scrollIntoView({behavior:'instant',block:'start'});$(`.form-step[data-step="${step}"] h2`).focus({preventScroll:true})}
}
function error(message,field){const box=$('#form-error');box.textContent=message;box.hidden=false;box.scrollIntoView({behavior:'instant',block:'center'});if(field){field.setAttribute('aria-invalid','true');field.focus({preventScroll:true})}return false}
function contactIssue(){
  if(!$('#first-name').value.trim())return ['Please enter your first name.',$('#first-name')];
  if(!$('#last-name').value.trim())return ['Please enter your last name.',$('#last-name')];
  if($('#phone').value.replace(/\D/g,'').length<10)return ['Enter a phone number with at least 10 digits.',$('#phone')];
  if(!$('#email').checkValidity())return ['Enter a valid email address.',$('#email')];
  return null;
}
function validateStep(){
  $$('[aria-invalid]').forEach(el=>el.removeAttribute('aria-invalid'));
  if(step===0&&!selectedServices().length)return error('Choose at least one service, or select “I\'m not sure”.',$('#service-oil'));
  if(step===1){const issue=contactIssue();if(issue)return error(...issue);}
  if(step===2){
    const lookupError=window.IgnitionVehicleLookup.validate();
    if(lookupError)return error(lookupError,$('#lookup-open'));
    if(!window.IgnitionVehicleLookup.hasSelection){
      if(!$('input[name="vehicle_type"]:checked'))return error('Choose your vehicle type.',$('input[name="vehicle_type"]'));
      if($('#year').value&&!$('#year').checkValidity())return error(`Enter a year between 1900 and ${new Date().getFullYear()+1}, or leave it blank.`,$('#year'));
      if(!$('#make').value.trim())return error('Enter the make of your vehicle.',$('#make'));
      if(!$('#model').value.trim())return error('Enter the model of your vehicle.',$('#model'));
    }
    if($('input[name="timing"]:checked').value==='Preferred date'&&!$('#preferred-date').checkValidity())return error('Choose today or a future date, or select “First available”.',$('#preferred-date'));
  }
  return true;
}
$$('.next-step').forEach(button=>button.addEventListener('click',()=>{if(validateStep())showStep(step+1)}));
$$('.previous-step').forEach(button=>button.addEventListener('click',()=>showStep(step-1)));
['year','make','model'].forEach(id=>root.querySelector('#'+id).addEventListener('input',updateSummary));
root.addEventListener('vehicle-lookup-change',updateSummary);
root.addEventListener('edit-booking-contact',()=>{showStep(1);$('#phone').focus({preventScroll:true});});
$$('input[name="contact_method"]').forEach(input=>input.addEventListener('change',()=>{const required=$('input[name="contact_method"]:checked').value==='Email';$('#email').required=required;$('#email-optional').textContent=required?'*':'(optional)'}));
$$('input[name="timing"]').forEach(input=>input.addEventListener('change',()=>{const preferred=$('input[name="timing"]:checked').value==='Preferred date';$('#date-field').hidden=!preferred;$('#preferred-date').required=preferred}));
const today=new Date();const localDate=new Intl.DateTimeFormat('en-CA',{timeZone:'America/Vancouver',year:'numeric',month:'2-digit',day:'2-digit'}).format(today);
$('#preferred-date').min=localDate;$('#year').max=today.getFullYear()+1;
form.addEventListener('input',event=>{event.target.removeAttribute('aria-invalid')});
function lockRequest(){
  if(!lockedControls)lockedControls=[...form.querySelectorAll('input,textarea,select,button,fieldset')].map(element=>({element,disabled:element.disabled}));
  lockedControls.forEach(({element})=>element.disabled=true);
}
function unlockRequest(){
  lockedControls?.forEach(({element,disabled})=>element.disabled=disabled);lockedControls=null;
  $('#submit-request').textContent='Request appointment';
}
function bookingPayload(){
  const selection=window.IgnitionVehicleLookup.selectionTokens();
  return {requestId:crypto.randomUUID(),firstName:$('#first-name').value.trim(),lastName:$('#last-name').value.trim(),
    mobile:$('#phone').value.trim(),email:$('#email').value.trim(),contactMethod:$('input[name="contact_method"]:checked').value,
    services:$$('input[name="services"]:checked').map(input=>input.value),notes:$('#notes').value.trim(),selection,
    vehicle:selection?null:{type:$('input[name="vehicle_type"]:checked')?.value,year:$('#year').value,make:$('#make').value.trim(),model:$('#model').value.trim()},
    usage:$('#usage').value.trim(),vin:$('#vin').value.trim(),timing:$('input[name="timing"]:checked').value==='Preferred date'?'preferred_date':'first_available',
    preferredDate:$('input[name="timing"]:checked').value==='Preferred date'?$('#preferred-date').value:'',pickup:$('#pickup').checked,website:$('#website').value};
}
async function sendBooking(){
  submitting=true;lockRequest();$('#form-error').hidden=true;form.setAttribute('aria-busy','true');$('#submit-request').textContent='Sending request…';
  const controller=new AbortController(),timer=setTimeout(()=>controller.abort(),30000);
  let result=null;
  try{
    const endpoint=new URL(bookingConfig.endpoint);
    if(endpoint.protocol!=='https:'||endpoint.username||endpoint.password||endpoint.search||endpoint.hash)throw new Error('configuration');
    const response=await fetch(new URL('/v1/requests',endpoint),{method:'POST',headers:{'Content-Type':'application/json'},
      body:JSON.stringify(pendingBooking),credentials:'omit',cache:'no-store',redirect:'error',signal:controller.signal});
    result=await response.json();
    if(response.ok&&result?.ok===true&&result.status==='received'&&/^[a-f0-9-]{36}$/.test(result.request_id||'')){
      requestReceipt=result;$('#request-reference').textContent='Request reference: '+result.request_id;$('#request-reference').hidden=false;
      location.hash='request-received';return;
    }
    if(['INVALID_INPUT','INVALID_JSON','BODY_TOO_LARGE','TRY_LATER','BOOKING_UNAVAILABLE','RIDE_SELECTION_EXPIRED','RIDE_LOOKUP_UNAVAILABLE'].includes(result?.error)){
      pendingBooking=null;unlockRequest();
      if(result.error==='RIDE_SELECTION_EXPIRED'||result.error==='RIDE_LOOKUP_UNAVAILABLE'){
        window.IgnitionVehicleLookup.reset();error('Your saved ride needs another check. Search again or enter your ride manually, then send your request.',$('#lookup-open'));
      }else error(result.error==='TRY_LATER'?'Please wait a little before trying again, or call us at 250-510-8844.':result.error==='INVALID_INPUT'?'Please check your contact, vehicle and date details, then try again.':'Requests are temporarily unavailable. Please try again later or call us at 250-510-8844.');
      return;
    }
    if(result?.error==='DELIVERY_UNCONFIRMED'||result?.error==='REQUEST_CHANGED'){
      $('#submit-request').textContent='Please contact service';
      error('We couldn’t confirm the full delivery of this request. Please call 250-510-8844 before submitting again. Your details are still here. Reference: '+(result.request_id||pendingBooking.requestId));return;
    }
    $('#submit-request').disabled=false;$('#submit-request').textContent='Check request status';
    error('Your request may still be processing. Choose “Check request status” to check the same request without creating a duplicate.');
  }catch{
    $('#submit-request').disabled=false;$('#submit-request').textContent='Check request status';
    error('The connection was interrupted. Your details are still here. Choose “Check request status” to safely check or finish sending the same request.');
  }finally{clearTimeout(timer);submitting=false;form.removeAttribute('aria-busy');}
}
form.addEventListener('submit',async event=>{
  if(submitting){event.preventDefault();return;}
  if(requestReceipt){event.preventDefault();location.hash='request-received';return;}
  if(pendingBooking){event.preventDefault();await sendBooking();return;}
  event.preventDefault();if(step<2){if(validateStep())showStep(step+1);return}
  if(!selectedServices().length){showStep(0);validateStep();return;}
  const issue=contactIssue();
  if(issue){showStep(1);error(...issue);return;}
  if(!validateStep())return;
  requestPreview={
    Services:selectedServices().join('\n'),
    Vehicle:[window.IgnitionVehicleLookup.hasSelection?null:$('input[name="vehicle_type"]:checked')?.value,[$('#year').value,$('#make').value.trim(),$('#model').value.trim()].filter(Boolean).join(' ')].filter(Boolean).join('\n'),
    'Vehicle selection':window.IgnitionVehicleLookup.summary(),
    Customer:[$('#first-name').value.trim(),$('#last-name').value.trim()].join(' '),
    Contact:[$('#phone').value.trim(),$('#email').value.trim()].filter(Boolean).join('\n'),
    'Reply by':$('input[name="contact_method"]:checked').value,
    Timing:$('input[name="timing"]:checked').value==='Preferred date'?$('#preferred-date').value+' (requested, not confirmed)':'First available',
    'Pickup / drop-off':$('#pickup').checked?'Please contact me to discuss':'Not requested',
    Notes:$('#notes').value.trim()||'No extra notes'
  };
  if($('#usage').value.trim())requestPreview['Mileage / hours']=$('#usage').value.trim();
  if($('#vin').value.trim())requestPreview.VIN=$('#vin').value.trim();
  const list=document.createElement('dl');list.className='result-details';
  Object.entries(requestPreview).forEach(([key,value])=>{const row=document.createElement('div');row.className='result-row';const term=document.createElement('dt');term.textContent=key;const detail=document.createElement('dd');detail.textContent=value;row.append(term,detail);list.append(row)});
  $('#result-details').replaceChildren(list);
  if(liveBooking){pendingBooking=bookingPayload();await sendBooking();}
  else location.hash='request-preview';
});
$('#edit-request').addEventListener('click',()=>{step=2;location.hash='book'});
$('#new-request').addEventListener('click',()=>{
  unlockRequest();form.reset();window.IgnitionVehicleLookup.reset();requestPreview=null;requestReceipt=null;pendingBooking=null;step=0;
  $('#request-reference').hidden=true;$('#date-field').hidden=true;$('#preferred-date').required=false;$('#email').required=false;$('#email-optional').textContent='(optional)';
  if(location.hash==='#book'){showStep(0);scrollTopPage();}else location.hash='book';
});
if(!liveBooking){
  $('#booking-send-note').textContent='Preview only — no request will be sent.';
  $('#result-eyebrow').textContent='BOOKING FLOW PREVIEW';$('#result-view h1').textContent='Your request, ready to review.';
  $('.result-intro').textContent='Preview only. No request has been sent.';$('#edit-request').hidden=false;$('#new-request').hidden=true;
}
window.addEventListener('hashchange',route);route();

})();
